/* eslint-disable max-len */
import React, { useContext, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useSelector } from 'react-redux';

const Toast = ({ message, type,setToastmessage }) => {
    const {loggedIn}=useSelector(state=>state.auth)
    const [showToast, setShowToast] = useState(true);

    /* This `useEffect` hook is setting a timer using `setTimeout` function to hide the toast message
    after 5 seconds (5000 milliseconds) and also resetting the `toastMessage` state to an empty
    string. The `clearTimeout` function is used to clear the timer when the component unmounts. The
    empty dependency array `[]` ensures that this effect runs only once when the component mounts. */
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowToast(false);
            setToastmessage('')
        }, 7000);

        return () => {
            clearTimeout(timer);
        };
    }, []);

    return (
        <>
            {showToast && (
                <motion.div
                    initial={{ x: 1000 }}
                    // ref={clickRef}
                    animate={{ x: 0 }}
                    transition={{ duration: 1 }}
                    data-testid="close-btn"
                    exit={{ opacity: 0.5 }}
                    onClick={()=>{setShowToast(!showToast); setToastmessage('')}}
                    style={{zIndex:'999'}}
                    className={`bg-[#9AD083] rounded-[12px] border-[1px] border-solid border-[#9AD083] flex space-x-2 py-4 px-4 absolute top-8 han right-5 items-center z-10 w-auto ${type}`}
                >
                    
                    <span>
                        {type === 'success' && <img src="/assets/images/check-circle.svg" alt="icon" />}
                        {/* {type === 'error' && <img src="/images/error-mark.svg" alt="icon" />} */}
                        {/* Add other icon options as needed */}
                    </span>
                    <p className="font-minionpro text-[#1F1F1F] w-[270px] font-normal text-xs test-left" id="toast-message">{message}</p>
                    <img
                        src="/assets/images/close-24px.svg"
                        className="cursor-pointer"
                        alt="close-svg"
                    />
                </motion.div>
            )}
        </>
    );
};

export default Toast;
